import messages from './borrar-modal-translations';
import * as $ from 'jquery';
import { BorrarMapaService } from './services/borrarMapaService';
import { ColaboraMapaService } from '../colabora-modal/services/colaboraMapaService';

export default {
    name: 'instamapsBorrarModal',
    i18n: {
        messages,
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        isLoadedColaborar: { type:Boolean },
        mapa: { type: Object },
    },
    methods: {
        show: function (colaborar) {
            setTimeout(function () {
                $('#borrar-modal').addClass('animate-flex-modal');
                if (colaborar !== "" && colaborar==="colaborar"){
                    $('#borrar-colaborador-mapa').attr("style", "display:block;");
                    $('#borrar-mapa').attr("style", "display:none;");
                }
                else {
                    $('#borrar-mapa').attr("style", "display:block;");
                    $('#borrar-colaborador-mapa').attr("style", "display:none;");
                }
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#borrar-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        borrarMapa: function(){
            BorrarMapaService.deleteMap(this.mapa.businessId).then((response) => {
                if (response.status==="OK") {
                    this.$emit('deleteMap', {businessId: this.mapa.businessId});
                    this.dismiss();
                }else{
                    this.dismiss();
                    this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
            });
        },
        borrarColaboradorMapa: function(){
            ColaboraMapaService.eliminarConvidatByUid(this.mapa.businessId).then((response) => {
                if (response.status==="OK") {
                    //enviar correu al propietari
                    this.sendMail(response.emailPropietari, response.emailConvidat);
                }else{
                    this.dismiss();
                    this.$emit('error', {title: this.$t('titleColaboratiu'), message: this.$t('responseKO')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('titleColaboratiu'), message: this.$t('responseKO')});
            });
        },
        sendMail: function(to, emailConvidat){
            let content = this.createEmailContent(emailConvidat);
            let esColaboratiu = 'N';
            let subject = this.$t('emailSubject');
            ColaboraMapaService.colaboraMap(this.mapa.businessId, to, subject, content, esColaboratiu).then((response) => {
                if (response.status==="OK") {
                    this.$emit('deleteColaborator');
                    this.dismiss();
                }else{
                    this.dismiss();
                    this.$emit('error', {title: this.$t('titleColaboratiu'), message: this.$t('responseKO')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('titleColaboratiu'), message: this.$t('responseKO')});
            });
        },
        createEmailContent: function(emailConvidat){
            let content = '';
            content = this.$t('emailContent');
            content = content.replace(/\${nom}/, this.mapa.nomAplicacio);
            content = content.replace(/\${email}/, emailConvidat);
           return content;
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
        'isLoadedColaborar': function(val){
            if(val){
                this.show('colaborar');
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/borrar-modal/borrar-modal.js